<ng-template appProductMenuSectionHeaderInflatorContainer></ng-template>
